<template>
  <div class="form-group row">
    <div class="col-12 row justify-content-md-center">
      <hr class="col-10">
    </div>

    <div class="col-sm-2 text-sm-right">
      <label>Número Protocolo:</label>
    </div>
    <div class="col-md-4 col-sm-10 mb-3">
      <the-mask :mask="['##/######/####']" type="text" class="form-control" v-model="filtro['processo']"/>
    </div>
    <div class="col-sm-2 text-sm-right">
      <label>Data Criação:</label>
    </div>
    <div class="col-md-4 col-sm-10 mb-3">
      <input type="date" class="form-control" v-model="date">
    </div>
    <div class="col-sm-2 text-sm-right">
      <label>Usuário Criação:</label>
    </div>
    <div class="col-md-4 col-sm-10 mb-3">
      <input type="text" class="form-control" v-model="filtro['atributos.autor']">
    </div>
    <div class="col-sm-2 text-sm-right">
      <label>Tipo Protocolo:</label>
    </div>
    <div class="col-md-4 col-sm-10 mb-3">
      <div class="form-check form-check-inline" v-for="(item) in tiposProtocolo" :key="item.key">
        <input class="form-check-input" type="radio" :name="`tipo-${item.key}`" :value="item.key" :id="`tipo-${item.key}`" v-model="filtro['atributos.tipoProtocolo']" checked>
        <label class="form-check-label" :for="`tipo-${item.key}`">{{ item.value }}</label>
      </div>
    </div>
    <div class="col-sm-2 text-sm-right">
      <label>Assunto:</label>
    </div>
    <div class="col-sm-10 mb-3">
      <input type="text" class="form-control" v-model="filtro['atributos.assunto']">
    </div>
    <div class="col-sm-2 text-sm-right">
      <label>Informação Complementar:</label>
    </div>
    <div class="col-sm-10 mb-3">
      <textarea class="form-control" rows="3" v-model.trim="filtro['atributos.textoComplemento']"/>
    </div>

    <div class="col-12 row justify-content-md-center">
      <hr class="col-10">
    </div>
  </div>
</template>

<script>
import { DateTools } from '@/uteis/datetime-tools'
import { mapState } from 'vuex'

export default {
  props: {
    progressName: { required: true, type: String }
  },

  data () {
    return {
      date: '',
      tiposProtocolo: [{
        value: 'Todos',
        key: undefined
      }, {
        value: 'Documento Avulso',
        key: 'Documento avulso'
      }, {
        value: 'Processo',
        key: 'Processo'
      }]
    }
  },

  created () {
    if (this.auxFiltroGeral.date) {
      this.date = this.auxFiltroGeral.date
    }
  },

  computed: mapState({
    filtro: state => state.filtroGeral,
    progress: state => state.progressFiltroGeral,
    auxFiltroGeral: state => state.auxFiltroGeral,
    progressProtocolo () {
      var count = 0
      var max = 6
      count += this.filtro.processo && this.filtro.processo !== '' ? 1 : 0
      count += this.filtro['atributos.autor'] && this.filtro['atributos.autor'] !== '' ? 1 : 0
      count += this.filtro['atributos.assunto'] && this.filtro['atributos.assunto'] !== '' ? 1 : 0
      count += this.filtro['atributos.dataCriacao'] && this.filtro['atributos.dataCriacao'] !== '' ? 1 : 0
      count += this.filtro['atributos.textoComplemento'] && this.filtro['atributos.textoComplemento'] !== '' ? 1 : 0
      count += this.filtro['atributos.tipoProtocolo'] && this.filtro['atributos.tipoProtocolo'] !== '' ? 1 : 0

      return (count / max) * 100
    }
  }),

  watch: {
    progressProtocolo (newValue) {
      if (newValue === 0) {
        this.date = ''
      }

      this.progress[this.progressName] = newValue.toFixed()
      this.progress.change = !this.progress.change
    },

    date (newValue) {
      this.$store.commit('MUT_AUX_FILTRO_PESQUISA_GERAL', {
        date: newValue
      })

      if (!newValue || newValue === '') {
        this.$store.commit('MUT_FILTRO_PESQUISA_GERAL', {
          'atributos.dataCriacao': ''
        })
        return
      }

      var date = new DateTools(newValue)

      var dataCriacao = `${date.json.monthName} ${date.json.UTCDate}, ${date.json.UTCFullYear}`
      this.$store.commit('MUT_FILTRO_PESQUISA_GERAL', {
        'atributos.dataCriacao': dataCriacao
      })
    }
  }
}
</script>
